import { Box, type BoxProps } from "@chakra-ui/react";

export const DraftCard = (props: BoxProps) => (
  <Box
    bg="smBackground"
    rounded="lg"
    border="1px solid"
    borderColor="smBorder"
    px={{ base: "4", md: "6" }}
    py="6"
    data-draft-card=""
    {...props}
  />
);
